import React from 'react';
import { createPortal } from 'react-dom';
import { CloseIcon } from './product_item_components/icons';

export function BranchSelectModal({
  isOpen,
  onClose,
  branches = [],
  selectedBranchName,
  includeAll = true,
  allLabel = 'Все',
  onSelect,
}) {
  React.useEffect(() => {
    if (!isOpen) return undefined;
    const onKey = (event) => {
      if (event.key !== 'Escape') return;
      onClose?.();
    };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  const modal = (
    <div
      className="main-page-modalOverlay"
      role="dialog"
      aria-modal="true"
      aria-label="Выберите филиал"
      onClick={() => onClose?.()}
    >
      <div className="main-page-modalCard" onClick={(e) => e.stopPropagation()}>
        <div className="main-page-modalHeader">
          <div className="main-page-modalTitle">Выберите филиал</div>
          <button
            type="button"
            className="main-page-modalClose"
            onClick={() => onClose?.()}
            aria-label="Закрыть"
            title="Закрыть"
          >
            <CloseIcon />
          </button>
        </div>

        <div className="main-page-modalList">
          {includeAll ? (
            <button
              type="button"
              className={
                selectedBranchName === null
                  ? 'main-page-modalItem main-page-modalItemSelected'
                  : 'main-page-modalItem'
              }
              onClick={() => onSelect?.(null)}
            >
              {allLabel}
            </button>
          ) : null}

          {branches.length === 0 ? (
            <div className="main-page-modalEmpty">Нет доступных филиалов.</div>
          ) : (
            branches.map((b) => (
              <button
                key={b._id ?? b.id ?? b.name}
                type="button"
                className={
                  selectedBranchName === b.name
                    ? 'main-page-modalItem main-page-modalItemSelected'
                    : 'main-page-modalItem'
                }
                onClick={() => onSelect?.(b)}
              >
                {b.name}
              </button>
            ))
          )}
        </div>
      </div>
    </div>
  );

  return typeof document !== 'undefined' ? createPortal(modal, document.body) : modal;
}

function BranchPicker({
  label = 'Филиал',
  placeholder = 'Все',
  branches = [],
  selectedBranchName,
  onSelectBranchName,
  disabled = false,
  hideLabel = false,
}) {
  const [isOpen, setIsOpen] = React.useState(false);
  const displayName = selectedBranchName || placeholder;

  return (
    <>
      <button
        type="button"
        className="main-page-branchButton"
        onClick={() => {
          if (disabled) return;
          setIsOpen(true);
        }}
        disabled={disabled}
      >
        {hideLabel ? null : (
          <div className="main-page-branchLeft">
            <div className="main-page-branchLabel">{label}</div>
            <div
              className={
                selectedBranchName
                  ? 'main-page-branchName'
                  : 'main-page-branchName main-page-branchNamePlaceholder'
              }
            >
              {displayName}
            </div>
          </div>
        )}

        {hideLabel ? (
          <div
            className={
              selectedBranchName
                ? 'main-page-branchName'
                : 'main-page-branchName main-page-branchNamePlaceholder'
            }
          >
            {displayName}
          </div>
        ) : null}
        <div className="main-page-branchChevron" aria-hidden="true">
          ▾
        </div>
      </button>

      <BranchSelectModal
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        branches={branches}
        selectedBranchName={selectedBranchName}
        allLabel={placeholder}
        onSelect={(branch) => {
          onSelectBranchName?.(branch ? branch.name : null);
          setIsOpen(false);
        }}
      />
    </>
  );
}

export default BranchPicker;

